export const VISITOR_UPDATED = 'VISITOR_UPDATED';
export const VISITOR_EMAIL_UPDATED = 'VISITOR_EMAIL_UPDATED';